module.exports = __webpack_public_path__ + "static/momentum_2024-767a0df7322f107b598df2623818cb8a.svg";